<section class="dynamic-filters" aria-labelledby="veeva-filter-heading">
  <div class="filters-header">
    <div>
      <h3 id="veeva-filter-heading">Veeva filters</h3>
      <p>Only fields available in the connected Vault are shown.</p>
    </div>
  </div>

  @if (loading()) {
    <div class="state-message" role="status">
      <mat-spinner [diameter]="24" />
      <span>Loading available filters…</span>
    </div>
  } @else if (loadFailed()) {
    <div class="state-message state-message--error" role="alert">
      <span>Available Veeva filters could not be loaded.</span>
      <button mat-stroked-button type="button" [disabled]="disabled()" (click)="loadFields()">
        Try again
      </button>
    </div>
  } @else if (fields().length === 0) {
    <div class="help-banner" role="note">
      <div>
        <strong>No import filters are available yet</strong>
        <p>
          Filters only appear after an admin validates Veeva taxonomies and marks fields as main filters in
          <a routerLink="/profile/api-settings">API settings → Taxonomy validation</a>.
        </p>
      </div>
    </div>
  } @else {
    <app-provider-filter-fields
      [fields]="fields()"
      [values]="selected()"
      [optionMap]="optionMap()"
      [optionLoadingMap]="optionLoading()"
      [optionErrorMap]="optionLoadFailed()"
      [disabled]="disabled()"
      (valueChanged)="setFieldValue($event)"
      (requestFieldOptions)="loadOptions($event)"
      (retryFieldOptions)="retryOptions($event)"
    />
  }
</section>
